import * as z from "zod";

export const getMerchantCenterAccounts = {
  name: "getMerchantCenterAccounts" as const,
  input: z.null(),
  output: z.object({
    accounts: z.array(z.object({ accountId: z.string(), name: z.string() })),
  }),
};
